module.exports = __webpack_public_path__ + "static/media/food-pattern.fb19d426.png";